import _ from 'lodash';
import Cons from '../../isomorphic/cons';

export default class EmailHelper {
    static generateRecipientsFromSkySlopeContacts(contacts) {
        let recipients = '';
        if (contacts || contacts.length !== 0){
            if (!Array.isArray(contacts)){
                    recipients = contacts.firstName !== undefined ? contacts.firstName : contacts;
            }else{
                if (contacts.length === 1){
                    recipients = contacts[0].firstName !== undefined ? contacts[0].firstName : contacts[0].email;
                } else if (contacts.length > 1){
                    let recipientArray = [];
                    for (let i = 0; i < contacts.length; i++) {
                        let contac = (contacts[i].firstName !== undefined ? contacts[i].firstName : (contacts[i].email !== undefined?contacts[i].email:contacts[i]));
                        if(recipientArray.indexOf(contac)==-1){
                            recipientArray.push(contac);
                        }
                    }
                    recipients = recipientArray.join(' & ')
                } 
            }
        }
        return recipients;
    }

    static generateEmailData(contacts, template, propsData) {
        const missingContacts = [];

        const filterContacts = (contactTypes) => {
            return _.flattenDeep(
                contactTypes.map((contactTypeId) => {
                    const foundContact = contacts.find((contact) => contact.contactTypeId === contactTypeId);
                    if (foundContact) {
                        return foundContact;
                    } else {
                        missingContacts.push(
                            `Please fill out the ${Cons.prime.getFileContactLabelById(
                                contactTypeId
                            )} contact info in SkySlope.`
                        );
                        return [];
                    }
                })
            );
        };
        const createRecipientList = (emails) => {
            return emails.map((recipient) => {
                    return `${
                        (recipient.name !== undefined ? recipient.name : '') ||  
                        (recipient.firstName !== undefined ? recipient.firstName + ' ' : '')  + (recipient.lastName !== undefined ? recipient.lastName : '')}
                        <${(recipient.email !== undefined ? recipient.email : recipient)}>`;
            });
        };

        const templateOptions = {
            toEmails: [],
            ccEmails: [],
            bccEmails: [],
        };
        //To
        if (template.settings && template.settings.toContactTypes) {
            templateOptions.toEmails = filterContacts(template.settings.toContactTypes);
        }
        
        const toEmails =EmailHelper.RemoveDuplicated(_.union(
            EmailHelper.splitEmails(propsData.toEmails),
            EmailHelper.splitEmails(template.settings.toEmails) || [],
            EmailHelper.splitEmails(templateOptions.toEmails) || []
        ));
        //CC
        if (template.settings && template.settings.ccContactTypes) {
            templateOptions.ccEmails = filterContacts(template.settings.ccContactTypes);
        }
        const ccEmails = EmailHelper.RemoveDuplicated(_.union(
            EmailHelper.splitEmails(propsData.ccEmails) || [],
            EmailHelper.splitEmails(template.settings.ccEmails) || [],
            EmailHelper.splitEmails(templateOptions.ccEmails) || []
        ));

        //BCC
        if (template.settings && template.settings.bccContactTypes) {
            templateOptions.bccEmails = filterContacts(template.settings.bccContactTypes);
        }
        const bccEmails = EmailHelper.RemoveDuplicated(_.union(
            EmailHelper.splitEmails(propsData.bccEmails) || [],
            EmailHelper.splitEmails(template.settings.bccEmails) || [],
            EmailHelper.splitEmails(templateOptions.bccEmails) || []
        ));

        return {
            missingContacts: missingContacts,
            toEmails: createRecipientList(toEmails),
            ccEmails: createRecipientList(ccEmails),
            bccEmails: createRecipientList(bccEmails),
            templateData: {
                recipients: EmailHelper.generateRecipientsFromSkySlopeContacts(toEmails),
            },
        };
    }

    //Clone an object if have an email with a comma
    static splitEmails(obj){
        let ret = [];
        if(obj==undefined) return ret;
        obj.forEach((e) => {
            try {
            if (e.email !=undefined){
                if (e.email.includes(',')) {
                    let m = e.email.split(',');
                    m.forEach((em) => {
                        let mObj=JSON.parse(JSON.stringify(e));
                        mObj.email = em;
                        ret.push(mObj);
                    });
                }
                else{ret.push(e);}
            } else {
                if (e.includes(',')) {
                    let m = e.split(',');
                    m.forEach((em) => {
                        ret.push(em);
                    });
                } else {ret.push(e);}
            }
        }catch(ee){console.log(ee)}
        });
        return ret;
    }

    static RemoveDuplicated(emails){
        let emailArray = [];
        emails.forEach((em) => {
            if(!emailArray.some(e => e.email === em.email)){
                emailArray.push(em);
            }
        });
        return emailArray;
    }
}



// WEBPACK FOOTER //
// ./src/utils/email-helper.js